const DPI = 96;
const SLIDE_WIDTH = 10;
const SLIDE_HEIGHT = 5.625;
const IMAGE_MARKDOWN_REGEX = /^!\[.*\]\(.*\)$/;
const IMAGE_SRC_REGEX = /\((.*?)\)/;

export function isImage(line: string): boolean {
    return IMAGE_MARKDOWN_REGEX.test(line);
}

export async function parseImage(line: string): Promise<any> {
    const imageSource = extractImageSource(line);
    if (imageSource) {
        const imageObject = await createImageObject(imageSource);
        return { ...imageObject, type: 'image' };
    }
    return null;
}

function extractImageSource(line: string): string | null {
    return line.match(IMAGE_SRC_REGEX)?.[1] || null;
}

async function createImageObject(imageSource: string): Promise<any> {
    const image = new Image();
    image.src = imageSource;
    await new Promise((resolve) => {
        image.onload = resolve;
    });

    const { width: imageWidth, height: imageHeight } = getScaledDimensions(image, SLIDE_WIDTH, SLIDE_HEIGHT);
    const { x: xPos, y: yPos } = getCenteredPosition(imageWidth, imageHeight, SLIDE_WIDTH, SLIDE_HEIGHT);

    return { data: imageSource, x: xPos, y: yPos, w: imageWidth, h: imageHeight };
}

function getCenteredPosition(imageWidth: number, imageHeight: number, slideWidth: number, slideHeight: number): { x: number, y: number } {
    const xPos = (slideWidth - imageWidth) / 2;
    const yPos = (slideHeight - imageHeight) / 2;
    return { x: xPos, y: yPos };
}

function getScaledDimensions(image: HTMLImageElement, maxWidth: number, maxHeight: number): { width: number, height: number } {
    let imageWidth = image.width / DPI;
    let imageHeight = image.height / DPI;
    if (imageWidth > maxWidth || imageHeight > maxHeight) {
        const widthRatio = maxWidth / imageWidth;
        const heightRatio = maxHeight / imageHeight;
        const scaleRatio = Math.min(widthRatio, heightRatio);
        imageWidth *= scaleRatio;
        imageHeight *= scaleRatio;
    }
    return { width: imageWidth, height: imageHeight };
}
